<template>

    <div class="totals" v-if="quoteRequest && quoteRequest.recipient">
      <div class="container">
        <div class="columns is-mobile">
          <div class="column is-one-third" style="position: relative;" v-show="!dateSubmitted" v-if="quoteRequest.calculationMethod === 0">
            <input type="checkbox" v-bind:checked="quoteRequest.recipient.isRegisteredForTax" v-bind:disabled="reopenVisible" id="cb_tax" @click="updateTaxCheckbox">
            <label class="checkbox" for="cb_tax">
              I'm Registered for {{quoteRequest.company.taxCode}}
            </label>
            <span class="text-autosave">Autosave is on</span>
          </div>
          <div class="column">
            <div class="total-items-wrapper">
              <div _v-if="computedRegisteredForTax || (quoteRequest.calculationMethod === 1)" class="total-items">Sub Total
                <span>{{itemSubTotal}}</span>
              </div>
              <div  _v-if="computedRegisteredForTax || (quoteRequest.calculationMethod === 1)" class="total-items">{{quoteRequest.company.taxCode}}
                <span>{{itemTaxTotal}}</span>
              </div>
              <div class="total-items  _total-items--top-border">Total
                <span>{{itemTotal}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>

export default {
  name: 'section-totals',
  props: ['quoteRequest', 'itemSubTotal', 'itemTaxTotal', 'itemTotal', 'reopenVisible', 'dateSubmitted', 'step', 'stepReached'],
  data () {
    return {
    }
  },
  methods: {
    updateTaxCheckbox (e) {
      this.$emit('updateTaxChk', e.target.checked)
      // Loops over items and update their amounts (as tax status changes)
      for (let index in this.quoteRequest.items) {
        this.$emit('commitItemAmount', index, this.quoteRequest.items[index].response.total)
      }
    }
  },
  computed: {

  },
  components: {
  }
}
</script>
